import { FC, MouseEventHandler } from 'react'
import { Link, LinkProps } from 'react-router-dom'
import { FilterPeriod } from 'src/constants/filterPeriods/enums/filterPeriod.enum'
import { useQueryParams } from 'src/hooks/useQueryParams'
import { GlobalQueryParams } from 'src/interfaces/globalQueryParams.interface'
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum'
import { createLink } from 'src/utils/createLink'

interface CustomLinkProps {
  children: LinkProps['children']
  className?: string
  inlineStyle?: any
  link: string
  onClick?: MouseEventHandler<HTMLAnchorElement>
}

const CustomLink: FC<CustomLinkProps> = ({
  className,
  inlineStyle,
  link,
  onClick,
  children,
}) => {
  const { queryParams } = useQueryParams<GlobalQueryParams>()

  const savedPeriod = localStorage.getItem(
    LocalStorageKey.DATE_FILTER_PERIOD
  ) as FilterPeriod | null

  return (
    <Link
      className={className}
      onClick={onClick}
      style={inlineStyle}
      to={createLink(link, {
        queryParams: {
          from: queryParams.from,
          period: queryParams.period || savedPeriod || FilterPeriod.LAST_7_DAYS,
          to: queryParams.to,
        },
      })}
    >
      {children}
    </Link>
  )
}

export default CustomLink
